import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ClientsService } from '@app/shared/services/clients.service';
import { OrderService } from '@app/shared/services/order.service';
import { Router } from '@angular/router';
import { JssService } from '@app/shared/services/jss.service';
import { MatAllotService } from '@app/shared/services/mat-allot.service';
import { MatMixService } from '@app/shared/services/mat-mix.service';
import { RepeatOrderService } from '@app/shared/services/repeat-order.service';
import {OrderDataService} from '@app/shared/services/order-data.service';
@Component({
  selector: 'app-place-order',
  templateUrl: './place-order.component.html',
  styleUrls: ['./place-order.component.css']
})
export class PlaceOrderComponent implements OnInit {
  clientList: any[] = [];
  showOrderForm = false;
  orderForm: FormGroup;
  addOrderForm: FormGroup;
  selectedClient: any;
  existingJob:FormGroup;  
  jsIdList: any[] = [];
  showExeForm:Boolean =false;

  constructor(
    private formBuilder: FormBuilder,
    private orderService: OrderService,private unsavedOrderDataService: OrderDataService,   
    private matMixService: MatMixService,
    private repeatService: RepeatOrderService,
    private clientService: ClientsService,    private jss: JssService, 
    private router: Router,  private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.orderForm = this.formBuilder.group({
      clientName: ['', [Validators.required]],
      orderOption: ['', [Validators.required]],
      ticketno: ['']

    });

    this.addOrderForm = this.formBuilder.group({
      ticketno: [''],
      clientName: [''],
      refNo: ['', [Validators.required]],
      poNo: ['', [Validators.required]],
      jobName: ['', [Validators.required]],
      jobType: ['', [Validators.required]],
      orderKgs: ['', [Validators.required]],
      gram: [''],
      orderPcs: [''], // Added a new form control to store the order type (Kg/Pcs)
      fdOption: ['', [Validators.required]],
      packageType: ['', [Validators.required]],
      customerRecipe: [''],
      recipeId: [''],
      sMat: ['', [Validators.required]],
      thickness: ['', [Validators.required]],
      width: ['', [Validators.required]],
      material1: this.formBuilder.group({
        sMat2: [''],
      thickness2: [''],
      width2: [''],
    }),
    material2: this.formBuilder.group({
      sMat3: [''],
      thickness3: [''],
      width3: [''],
  }),
      
      poDate: ['', [Validators.required]],
      ddDate: ['', [Validators.required]],
      coilWidth: ['', [Validators.required]],
      coilod: ['', [Validators.required]],
      sRemrk: ['', [Validators.required]],
      barcode: ['', [Validators.required]],
      dispatch: ['', [Validators.required]],
      remark: ['', [Validators.required]],
      prepare: ['', [Validators.required]],
      approved: ['', [Validators.required]],
    });
    
      this.existingJob = this.formBuilder.group({
        clientName: [''],
        ticketno: [''],
        jssId: [''],
        jobName: [''],
        avgWastage: ['',Validators.required],
        repeatedRemarks:[''],
        waste:[''],
        jssfolderno: [''],
        poNo: [''],
        poDate: [''],
        ddDate: [''],
        orderPcs: [''],
        gram: [''],
        refNo: [''],
        coilWidth: [''],
        coilod: [''],
        printType: [''],
        repeatLength: [''],
        printDirection: [''],
        fdOption: [''],
        packageType: [''],
        remark: [''],
        std: [''],
        totalGsm: [''],
        colorNames: [''],
        colorNumber: [''],
        jobType: [''],
        orderKgs: [''],
        LamType: [''],
        coreType: [''],
        liquid: [''],
        inkType: [''],
        barcode: [''],
        dispatch:[''],
        sRemrk:[''],
       
        cylinders: this.formBuilder.group({
          id: [''],
          supplier: [''],
          length: [''],
          circumference: [''],
          location: [''],
        }),
        gluing: [''], // Gluing Rolls control
        nco: [''],
        oh: [''], 
        
        cutting: [''], // Cutting Size control
        prepared: ['', [Validators.required]], // Prepared by control
        approved: ['', [Validators.required]],
      });
      

    this.getClients();
    
  }
  resetmaterial1(): void {
    const material1= this.addOrderForm.get('material1') as FormGroup;
    material1.get('sMat2')?.setValue('');
    material1.get('thickness2')?.setValue('');
    material1.get('width2')?.setValue('');
}
resetmaterial2(): void {
  const material2= this.addOrderForm.get('material2') as FormGroup;
  material2.get('sMat3')?.setValue('');
  material2.get('thickness3')?.setValue('');
  material2.get('width3')?.setValue('');
}
  
  getClients() {
    this.clientService.getClientList().subscribe(
      (data: any) => {
        this.clientList = data;
        this.cdr.detectChanges();
      },
      (error) => {
        console.error('Error fetching clients:', error);
      }
    );
  }

  toggleView() {
    this.showOrderForm = !this.showOrderForm;
    if (!this.showOrderForm) {
      this.orderForm.reset();
    }
  }


  handleNext(): void {
    const orderOption = this.orderForm.get('orderOption')?.value;
    if (orderOption === 'newJob') {
      this.NewJob();
    } else if (orderOption === 'existingJob') {
      this.ExtJob();
    }
  }
  
  getTicketNo() {
    return new Promise((resolve, reject) => {
      this.orderService.getHighestTicketNumber().subscribe((highestTicketNo: any) => {
        // Generate the ticket number based on current month and year
        const now = new Date();
        const year = now.getFullYear().toString().slice(-2); // Last 2 digits of the year
        const month = (now.getMonth() + 1).toString().padStart(2, '0');
        
        // Check if highest ticket number matches current month and year
        if (highestTicketNo && highestTicketNo.startsWith(`${year}${month}`)) {
          // Extract the current sequence number
          const lastCount = parseInt(highestTicketNo.slice(-3), 10);
          const nextCount = (lastCount >= 999) ? 1 : lastCount + 1; // Increment or reset to 1 if limit reached
          const incrementCount = this.formatNumber(nextCount);
          resolve(`${year}${month}${incrementCount}`);
        } else {
          // If no tickets for current month or year, start with 001
          resolve(`${year}${month}001`);
        }
      });
    });
  }
  
  private setOrderForm(ticketNumber: string): void {
    const selectedClientId = this.orderForm.get('clientName')?.value;
    this.selectedClient = this.clientList.find(client => client._id === selectedClientId);
  
    this.addOrderForm.patchValue({
      ticketno: ticketNumber,
      clientName: this.selectedClient?.clientName,
    });
  
    this.showOrderForm = true;
    this.showExeForm = false;
    this.cdr.detectChanges();
  }
  
  private NewJob(): void {
    this.getTicketNo().then((ticketNo: string) => {
      this.setOrderForm(ticketNo);
    });
  }
  
  private formatNumber(num: number): string {
    return num.toString().padStart(3, '0');
  }
  

isSubmitting: boolean = false;
  // working one
  // addOrder(): void {
  //   console.log('Form Data:', this.addOrderForm.value);
  //   if (this.addOrderForm.valid) {
  //     this.orderService.addOrder(this.addOrderForm.value).subscribe(
  //       (res: any) => {
  //         console.log(res);
  //         this.addOrderForm.reset();
  //         this.router.navigate(['/orderList']);
  //       },
  //       (err: any) => {
  //         console.log(err);
  //       }
  //     );
  //   }
  // }
  // now with disabling fetaure
  addOrder(): void {
  console.log('Form Data:', this.addOrderForm.value);
  
  if (this.addOrderForm.valid) {
    this.isSubmitting = true;  // Disable the button
     // Log to the console when the form starts submitting
    console.log('isSubmitting is now true: Data is being submitted...');

    this.orderService.addOrder(this.addOrderForm.value).subscribe(
      (res: any) => {
        console.log(res);
        this.addOrderForm.reset();
        this.router.navigate(['/orderList']);  // Navigate to the order list page
        // Log a success message
        console.log('Data has been successfully submitted and saved!');
      },
      (err: any) => {
        console.log(err);
        this.isSubmitting = false;  // Re-enable the button if there's an error
      }
    );
  }
}
// just to check whether that spinner is working or not
// addOrder(): void {
//   console.log('Form Data:', this.addOrderForm.value);
  
//   if (this.addOrderForm.valid) {
//     this.isSubmitting = true;  // Disable the button

//     // Log to the console when the form starts submitting
//     console.log('isSubmitting is now true: Data is being submitted...');
    
//     // Simulate a delay to see the spinner in action (e.g., 3 seconds)
//     setTimeout(() => {
//       console.log('Simulating data submission...');

//       // Simulate a successful submission
//       this.orderService.addOrder(this.addOrderForm.value).subscribe(
//         (res: any) => {
//           console.log('Order submitted successfully:', res);
//           this.addOrderForm.reset();
//           this.router.navigate(['/orderList']);  // Navigate to the order list page

//           // Log a success message
//           console.log('Data has been successfully submitted and saved!');
//         },
//         (err: any) => {
//           console.log('Error submitting data:', err);
//           this.isSubmitting = false;  // Re-enable the button if there's an error

//           // Log an error message
//           console.log('Error occurred while submitting data.');
//         }
//       );
//     }, 3000); // Simulate a 3-second delay (3000ms)
//   } else {
//     console.log('Form is invalid. Please fill in all required fields.');
//   }
// }

  showPcsGram: boolean = false;
  totalPcs: number = 0;
  calculateTotalPcs() {
    const orderPcs = +this.addOrderForm.get('orderPcs')?.value;
    this.totalPcs=orderPcs;

  }

  togglePcsGram() {
    this.showPcsGram = !this.showPcsGram;
   this.calculateTotalPcs();
  }

  // calculateOrderKgs() {
  //   const orderPcs = this.existingJob.get('orderPcs')?.value;
  //   const gramValue = this.existingJob.get('gram')?.value;
  
  //   // Your calculation logic here
  //   if (orderPcs && gramValue) {
  //     const calculatedKgs = (gramValue / 1000) * orderPcs; // Example calculation
  //     this.existingJob.get('orderKgs')?.setValue(calculatedKgs);
  //   } else {
  //     this.existingJob.get('orderKgs')?.setValue(0); // Set to 0 if inputs are invalid
  //   }
  // }
  calculateOrderKgs() {
    const pcsGram = parseFloat(this.addOrderForm.get('gram')?.value) || 0;
    if (pcsGram !== 0) {
      const calculatedKgs = this.totalPcs / pcsGram;
      console.log(calculatedKgs);
      this.addOrderForm.get('orderKgs')?.setValue(calculatedKgs.toFixed(2)); // Set value in orderKgs input field
    }
  }
  

  
//////////////////exsting order form

calculateOrderKgsExit() {
  const orderPcs = this.existingJob.get('orderPcs')?.value;
  const gramValue = this.existingJob.get('gram')?.value;

  // Your calculation logic here
  if (orderPcs && gramValue) {
    const calculatedKgs = (orderPcs/gramValue); // Example calculation
    this.existingJob.get('orderKgs')?.setValue(calculatedKgs);
  } else {
    this.existingJob.get('orderKgs')?.setValue(0); // Set to 0 if inputs are invalid
  }
}


  newTicketNumber: string | null = null; // Class-level variable to store the new ticket number

  ExtJob(): void {
    // Get the selected client from the form
    const selectedClientId = this.orderForm.get('clientName')?.value;
    this.selectedClient = this.clientList.find(client => client._id === selectedClientId);
  
    // Generate the datePrefix in yymm format
    const now = new Date();
    const year = now.getFullYear().toString().slice(-2); // Last 2 digits of the year
    const month = (now.getMonth() + 1).toString().padStart(2, '0');
    const datePrefix = `${year}${month}`;
  
    // Generate the new ticket number and update the existingJob form
    this.getTicketNo().then((ticketNo: string) => {
      // Update the existingJob form with the new ticket number
      this.existingJob.patchValue({
        clientName: this.selectedClient?.clientName,
        ticketno: ticketNo,
      });
  
      // Log the form values after patching
      console.log('Existing Job Form Values after patching:', this.existingJob.value);
  
      // Fetch job list and set form to show
      this.updateJobList(this.selectedClient?.clientName);
      this.showOrderForm = true; // Show the form for existing jobs
      this.showExeForm = false; // Hide the form for new jobs
      this.cdr.detectChanges(); // Ensure view is updated after setting showOrderForm
    }).catch(error => {
      console.error('Error generating ticket number:', error);
    });
  
    // The old code to fetch highest ticket number is removed as we're using getTicketNo directly
  }
  
  
  
  
  
   
  
  
  combinedMaterials: any[] = [];
  
  updateJobList(clientName: string) {
    this.jss.getJssRecords(clientName).subscribe(
      (response: { refNo: string }[]) => {
        console.log('Response from JSS records:', response);
  
        this.jsIdList = response.map(record => record.refNo);
  
        if (this.jsIdList.length > 0) {
          this.showExeForm = true;
          // Ensure view updates with showExeForm
          this.cdr.detectChanges();
        }
  
        console.log(this.jsIdList);
      },
      (error) => {
        console.error('Error fetching JSS records:', error);
      }
    );
  }
  
 
  onrefNoChange(selectedrefNo: string): void {
    if (!selectedrefNo) {
      console.warn('No refNo name selected');
      return;
    }
  
    this.jss.getJssIdsByrefNo(selectedrefNo).subscribe(
      (response: { id: string }[]) => {
        if (response.length > 0) {
          const jssId = response[0].id;
          console.log('Fetched JSS ID:', jssId);
  
          this.existingJob.patchValue({ jssId });
         // this.fetchUnsavedJssDetails(jssId);
          this.fetchJssDetails(jssId);
          // Ensure view updates after patching jssId
          this.cdr.detectChanges();
        } else {
          console.warn('No JSS ID found for the selected refNo');
        }
      },
      (error) => {
        console.error('Error fetching JSS ID:', error);
      }
    );
   
  }





fetchJssDetails(jssId: string) {
  if (!jssId) return;

  // Fetch JSS details
  this.jss.getJssById(jssId).subscribe(
    (data: any) => {
      if (data) {
        // Patch the form with JSS data
        this.existingJob.patchValue({
          clientName: data.clientName || '',
          jssfolderno: data.jssfolderno || '',
          poNo:'',
          refNo: data.refNo || '',
          coilWidth: data.coilWidth || '',
          coilod: data.coilod || '',
          printType: data.printType || '',
          fdOption: data.fdOption || '',
          ddDate:'',
          totalGsm: data.totalGsm || '',
          packageType: data.packageType || '',
          remark: data.remark || '',
          repeatLength: data.repeatLength || '',
          printDirection: data.printDirection || '',
          std: data.std || '',
          pouch: '',
          colorNames: data.colorNames || '',
          colorNumber: data.colorNumber || '',
          jobName: data.jobName || '',
          jobType: data.jobType || '',
          orderKgs: '',
          LamType: data.LamType || '',
          coreType: data.coreType || '',
          liquid: data.liquid || '',
          inkType: data.inkType || '',
          barcode: data.barcode || '',
          dispatch: data.dispatch || '',
          sRemrk: data.sRemrk || '',
          cylinders: {
            id: data.cylinders?.id || '',
            supplier: data.cylinders?.supplier || '',
            length: data.cylinders?.length || '',
            circumference: data.cylinders?.circumference || '',
            location: data.cylinders?.location || ''
          },
        });

        // Fetch unsaved data
        this.unsavedOrderDataService.getUnsavedOrderByJssId(jssId).subscribe(
          (unsaved: any) => {
            console.log('Unsaved data:', unsaved);
            if (Array.isArray(unsaved) && unsaved.length > 0) {
              const unsavedData = unsaved[0];
              this.existingJob.patchValue({
                nco: unsavedData.nco || '',
                oh: unsavedData.oh || '',
                gluing: unsavedData.gluing || '',
                cutting: unsavedData.cutting|| '',
              });
              console.log('Form after patching:', this.existingJob.value);
              this.cdr.detectChanges();
            } else {
              console.warn('No unsaved data found or data structure is incorrect.');
            }
          },
          (err: any) => {
            console.error('Error fetching unsaved data:', err);
          }
        );

        // Fetch MatMix data
        this.matMixService.getMatMixByOrderId(jssId).subscribe(
          (matMix: any) => {
            if (matMix.length > 0) {
              const firstItem = matMix[0];
              this.existingJob.patchValue({ avgWastage: firstItem.orderper });
              const materials = firstItem.Materials || [];
              this.combinedMaterials = materials.map(material => ({
                ...material,
                waste: material.waste || 0 // Default waste if not present
              }));

              console.log('Combined Materials:', this.combinedMaterials);

              // Perform calculations and updates
              this.calculateGrandTotalGsm();
              this.calculateAndLogGsm();
              this.cdr.detectChanges();
            } else {
              // Show alert if no MatMix data found
              alert('No MatMix data found for the selected JSS ID.');

              // Redirect to /materialMix after the alert
             // this.router.navigate(['/materialMix']);
            }
          },
          (err: any) => {
            console.error('Error fetching MatMix data:', err);
          }
        );
      } else {
        console.error('No data found for jssId:', jssId);
      }
    },
    (error) => {
      console.error('Error fetching JSS details:', error);
    }
  );
}

  
 
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  initialOrderper: number; // Initialize initialOrderper
  updateOperperValue(): number {
    const orderper = parseFloat(this.existingJob.value.avgWastage);
    const orderKgs = parseFloat(this.existingJob.value.orderKgs);
    // Store the initial orderper value
    this.initialOrderper = orderper;
    // Calculate the new value for orderper based on the formula
    const newOrderper = ((orderKgs * orderper) / 100) + orderKgs;
  
  
  
    // Return the calculated newOrderper value to be used in addMaterial()
    return newOrderper;
  }

  calculateGsm(thickness: number, density: number): number {
    const gsm = thickness * density;
    return parseFloat(gsm.toFixed(2)); // Convert to number and round to 2 decimal places
  }
  
  calculateAndLogGsm(): void {
    this.combinedMaterials.forEach(material => {
      const thickness = material.thickness;
      const density = material.density;
      const gsm = this.calculateGsm(thickness, density);
  
      // Log the material and its GSM
      console.log(`Material: ${material.material}, Thickness: ${thickness}, Density: ${density}, GSM: ${gsm}`);
      
      // Optionally, update the material object with the calculated GSM
      material.gsm = gsm;
    });
    
    // Optionally, log the entire updated list
    console.log('Updated Combined Materials:', this.combinedMaterials);
  }
  
  
  grandTotalGsm: number = 0; // Variable to hold the grand total GSM

  calculateGrandTotalGsm(): void {
    // Log individual GSM values
    this.combinedMaterials.forEach(item => {
      console.log(`Material: ${item.material}, GSM: ${item.gsm}`);
    });
  
    // Calculate and log the total GSM
    this.grandTotalGsm = this.combinedMaterials.reduce((total, item) => total + (parseFloat(item.gsm) || 0), 0);
    console.log('Total GSM of all materials:', this.grandTotalGsm);
  }
  

  grandTotalMatReq = 0;
  wasteInKg = 0;
  calcMatReq(material: any) {
    // Check if already calculated
    if (material.calculated) {
      // If already calculated, recalculate matRequired based on updated waste value
      const orderKgs = parseFloat(this.existingJob.value.orderKgs);
      const thickness = parseFloat(material.thickness);
      const densityValue = parseFloat(material.density);
      const wastePercentage = parseFloat(material.waste);
      const orderper = this.updateOperperValue();
  
      const gsm = this.calculateGsm(thickness, densityValue);
      const netRm = (gsm * orderper) / this.grandTotalGsm;
      const newMatRequired = (wastePercentage * netRm / 100) + netRm;
  
      // Calculate the difference with previous matRequired before updating
      const previousMatReq = parseFloat(material.matRequired);
      const matReqDiff = newMatRequired - previousMatReq;
  
      // Adjust grandTotalMatReq and wasteInKg based on the difference
      this.grandTotalMatReq -= previousMatReq; // Subtract previous matRequired
      this.grandTotalMatReq += newMatRequired; // Add new matRequired
      this.wasteInKg = this.grandTotalMatReq - orderKgs;
  
      // Update values in the material object
      material.netRm = netRm.toFixed(2);
      material.matRequired = newMatRequired.toFixed(2);
  
      // Optionally log values for debugging
      console.log("Previous GSM total:", this.grandTotalGsm);
      console.log("Updated grandTotalMatReq total:", this.grandTotalMatReq);
      console.log("Updated wasteInKg total:", this.wasteInKg);
      console.log('Material netRm:', material.netRm);
      console.log('Material matRequired:', material.matRequired);
      console.log("Previous matRequired:", previousMatReq);
  
      console.log('Material:', material);
  
      return; // Exit function since recalculation is done
    }
  
    // Set 'calculated' flag to true after performing calculations
    material.calculated = true;
  
    // Initial calculation flow for first time calculation
    const orderKgs = parseFloat(this.existingJob.value.orderKgs);
    const thickness = parseFloat(material.thickness);
    const densityValue = parseFloat(material.density);
    const wastePercentage = parseFloat(material.waste);
    const orderper = this.updateOperperValue();
  
    const gsm = this.calculateGsm(thickness, densityValue);
    const netRm = (gsm * orderper) / this.grandTotalGsm;
    const matRequired = (wastePercentage * netRm / 100) + netRm;
  
    // Update values in the material object
    material.netRm = netRm.toFixed(2);
    material.matRequired = matRequired.toFixed(2);
  
    // Update grandTotalMatReq and wasteInKg
    this.grandTotalMatReq += matRequired;
    this.wasteInKg = this.grandTotalMatReq - orderKgs;
  
    // Optionally log values for debugging
    console.log("Previous GSM total:", this.grandTotalGsm);
    console.log("Updated grandTotalMatReq total:", this.grandTotalMatReq);
    console.log("Updated wasteInKg total:", this.wasteInKg);
    console.log('Material netRm:', material.netRm);
    console.log('Material matRequired:', material.matRequired);
  
    console.log('Material:', material);
  }


  isSaving: boolean = false;
  // saveAndContinue(): void {
  //   // Display a confirmation dialog before saving
  //   if (!confirm('Are you sure you want to save?')) {
  //     return; // If user cancels, do not proceed with saving
  //   }
  
  //   // Access form data from this.existingJob
  //   const formData = this.existingJob.value;
  
  //   // Prepare data object to save
  //   const dataToSave = {
  //     ticketno: formData.ticketno,
  //     orderId: formData.jssId,
  //     clientName: formData.clientName,
  //     jobName: formData.jobName,
  //     poNo: formData.poNo,
  //     ddDate:formData.ddDate,
  //     avgWastage: parseFloat(formData.avgWastage),
  //     waste: formData.waste,
  //     jssfolderno: formData.jssfolderno,
  //     refNo: formData.refNo,
  //     fdOption :formData.fdOption,
  //     packageType :formData.packageType,
  //     remark :formData.remark,
  //     coilWidth: formData.coilWidth,
  //     coilod: formData.coilod,
  //     printType: formData.printType,
  //     repeatLength: formData.repeatLength,
  //     printDirection: formData.printDirection,
  //     std: formData.std,
  //     orderPcs:formData.orderPcs,
  //     gram: formData.gram,
  //     poDate:formData.poDate,
  //     totalGsm: formData.totalGsm,
  //     colorNames: formData.colorNames,
  //     colorNumber: formData.colorNumber,
  //     jobType: formData.jobType,
  //     orderKgs: parseFloat(formData.orderKgs),
  //     LamType: formData.LamType,
  //     coreType: formData.coreType,
  //     liquid: formData.liquid,
  //     inkType: formData.inkType,
  //     barcode: formData.barcode,
  //     dispatch:formData.dispatch,
  //     sRemrk:formData.sRemrk,

  //     repeatedRemarks:formData.repeatedRemarks,

  //     nco: formData.nco,
  //     oh: formData.oh, 
  //     gluing:formData.gluing, // Gluing Rolls control
  //     cutting:formData.cutting, // Cutting Size control
  //     prepared:formData.prepared, // Prepared by control
  //     approved:formData.approved,
  //     cylinders: {
  //       id: formData.cylinders.id,
  //       supplier: formData.cylinders.supplier,
  //       length: formData.cylinders.length,
  //       circumference: formData.cylinders.circumference,
  //       location: formData.cylinders.location
  //     },
  //     combinedMaterials: this.combinedMaterials // Assuming this is defined elsewhere
  //   };
  
  //   // Call the service to save data
  //   this.repeatService.repeatOrder(dataToSave).subscribe(
  //     response => {
  //       console.log('Data saved successfully:', response);
  //       // Optionally reset form or perform other actions after successful save
  
  //       // Redirect to the desired route after saving
  //       this.router.navigate(['/repeatedorderlist']);
  //       // this.router.navigate(['/matAllot'], { queryParams: { orderId: this.orderId } });
  //     },
  //     error => {
  //       console.error('Error saving data:', error);
  //       // Handle error scenario
  //     }
  //   );
  // }
  saveAndContinue(): void {
  // Display a confirmation dialog before saving
  if (!confirm('Are you sure you want to save?')) {
    return; // If user cancels, do not proceed with saving
  }

  // Access form data from this.existingJob
  const formData = this.existingJob.value;

  // Prepare data object to save
  const dataToSave = {
    ticketno: formData.ticketno,
    orderId: formData.jssId,
    clientName: formData.clientName,
    jobName: formData.jobName,
    poNo: formData.poNo,
    ddDate: formData.ddDate,
    avgWastage: parseFloat(formData.avgWastage),
    waste: formData.waste,
    jssfolderno: formData.jssfolderno,
    refNo: formData.refNo,
    fdOption: formData.fdOption,
    packageType: formData.packageType,
    remark: formData.remark,
    coilWidth: formData.coilWidth,
    coilod: formData.coilod,
    printType: formData.printType,
    repeatLength: formData.repeatLength,
    printDirection: formData.printDirection,
    std: formData.std,
    orderPcs: formData.orderPcs,
    gram: formData.gram,
    poDate: formData.poDate,
    totalGsm: formData.totalGsm,
    colorNames: formData.colorNames,
    colorNumber: formData.colorNumber,
    jobType: formData.jobType,
    orderKgs: parseFloat(formData.orderKgs),
    LamType: formData.LamType,
    coreType: formData.coreType,
    liquid: formData.liquid,
    inkType: formData.inkType,
    barcode: formData.barcode,
    dispatch: formData.dispatch,
    sRemrk: formData.sRemrk,
    repeatedRemarks: formData.repeatedRemarks,
    nco: formData.nco,
    oh: formData.oh,
    gluing: formData.gluing, // Gluing Rolls control
    cutting: formData.cutting, // Cutting Size control
    prepared: formData.prepared, // Prepared by control
    approved: formData.approved,
    cylinders: {
      id: formData.cylinders.id,
      supplier: formData.cylinders.supplier,
      length: formData.cylinders.length,
      circumference: formData.cylinders.circumference,
      location: formData.cylinders.location
    },
    combinedMaterials: this.combinedMaterials // Assuming this is defined elsewhere
  };

  // Set isSaving to true when the submission starts
  this.isSaving = true;
  //  console.log('repeated order is saving:', this.isSaving);
  console.log('isSaving is now true: repeated order Data is being submitted...');

  // Call the service to save data
  this.repeatService.repeatOrder(dataToSave).subscribe(
    response => {
      console.log('Data saved successfully:', response);
      // Optionally reset form or perform other actions after successful save

      // Redirect to the desired route after saving
      this.router.navigate(['/repeatedorderlist']);
    },
    error => {
      console.error('Error saving data:', error);
      // Handle error scenario
    },
    () => {
      // Reset the isSaving flag after the request is completed (success or error)
      this.isSaving = false;
    }
  );
}
  
  
  
}



























//   fetchUnsavedJssDetails(jssId: string) {
//   this.unsavedOrderDataService.getUnsavedOrderByJssId(jssId).subscribe(
//     (unsaved: any) => {
//       console.log('Unsaved data:', unsaved);  // Log full unsaved data

//       // Check if unsaved is an array or an object and handle accordingly
//       if (Array.isArray(unsaved) && unsaved.length > 0) {
//         const unsavedData = unsaved[0];  // Assuming the first element holds the relevant data

//         // Patch the values you need into the form
//         this.existingJob.patchValue({
//           nco: unsavedData.nco || '',
//           oh: unsavedData.oh || '',
       
//         });

//         // Log the form values after patching
//         console.log('Form after patching:', this.existingJob.value);

//         // Trigger change detection
//         this.cdr.detectChanges();
//       } else {
//         console.warn('No unsaved data found or data structure is incorrect.');
//       }
//     },
//     (err: any) => {
//       console.error('Error fetching unsaved data:', err);
//     }
//   );
// }


 // onJobNameChange(selectedJobName: string): void {
  //   if (!selectedJobName) {
  //     console.warn('No job name selected');
  //     return;
  //   }
  
  //   this.jss.getJssIdsByJobName(selectedJobName).subscribe(
  //     (response: { id: string }[]) => {
  //       if (response.length > 0) {
  //         const jssId = response[0].id;
  //         console.log('Fetched JSS ID:', jssId);
  
  //         this.existingJob.patchValue({ jssId });
  //         this.fetchJssDetails(jssId);
  //         // Ensure view updates after patching jssId
  //         this.cdr.detectChanges();
  //       } else {
  //         console.warn('No JSS ID found for the selected job name');
  //       }
  //     },
  //     (error) => {
  //       console.error('Error fetching JSS ID:', error);
  //     }
  //   );
   
  // }


 // fetchJssDetails(jssId: string) {
  //   if (!jssId) return;

  //   // Fetch JSS details
  //   this.jss.getJssById(jssId).subscribe(
  //     (data: any) => {
  //       if (data) {
       
  //         // Patch the form with JSS data
  //         this.existingJob.patchValue({
  //           clientName: data.clientName || '',
  //          //ticketno: data.ticketno || '',
  //           jssfolderno: data.jssfolderno || '',
  //           poNo: data.poNo || '',
  //           refNo: data.refNo || '',
  //           coilWidth: data.coilWidth || '',
  //           coilod: data.coilod || '',
  //           printType: data.printType || '',
  //           fdOption: data.fdOption || '',
  //           ddDate: data.ddDate || '',
  //           packageType: data.packageType || '',
  //           remark: data.remark || '',
  //           repeatLength: data.repeatLength || '',
  //           printDirection: data.printDirection || '',
  //           std: data.std || '',
  //           pouch: data.pouch || '',
  //           totalGsm: data.totalGsm || '',
  //           colorNames: data.colorNames || '',
  //           colorNumber: data.colorNumber || '',
  //           jobName: data.jobName || '',
  //           jobType: data.jobType || '',
  //           orderKgs: data.orderKgs || '',
  //           LamType: data.LamType || '',
  //           coreType: data.coreType || '',
  //           liquid: data.liquid || '',
  //           inkType: data.inkType || '',
  //           barcode: data.barcode || '',
  //           cylinders: {
  //             id: data.cylinders?.id || '',
  //             supplier: data.cylinders?.supplier || '',
  //             length: data.cylinders?.length || '',
  //             circumference: data.cylinders?.circumference || '',
  //             location: data.cylinders?.location || ''
  //           },
  //         });
  
  //         // Fetch MatMix data
  //         this.matMixService.getMatMixByOrderId(jssId).subscribe(
  //           (matMix: any) => {
  //             if (matMix.length > 0) {
  //               const firstItem = matMix[0];
  //               this.existingJob.patchValue({ avgWastage: firstItem.orderper });
  
  //               const materials = firstItem.Materials || [];
  //               //const exMaterials = firstItem.exMaterials || [];
  
  //               // Initialize combined materials
  //               this.combinedMaterials = [...materials];
  //               console.log('Initial Combined Materials:', this.combinedMaterials);
  
  //               //Fetch MatAllot data
  //               this.matAllotService.getMatAllotByOrderId(jssId).subscribe(
  //                 (matAllotData: any) => {
  //                   if (matAllotData && matAllotData.length > 0) {
  //                     const materialProcesses = matAllotData[0].materialProcesses || [];
  //                     console.log(matAllotData)
  //                     // debugger
  //                     // Update combinedMaterials with processes
  //                     this.combinedMaterials = this.combinedMaterials.map((material: any) => {
  //                       const process = materialProcesses.find((p: any) =>
  //                         p.material === material.material || p.material === material.extMat
  //                       );
  
  //                       if (process) {
  //                         // Update material with process data but preserve original waste value
  //                         return {
  //                           ...material,
  //                           process: process.process,
  //                           processId: process.processId,
  //                           density: process.density || material.density,
  //                           thickness: process.thickness || material.thickness,
  //                           waste: material.waste // Preserve original waste value
  //                         };
  //                       }
  //                       return material;
  //                     });
  //                     //  this.combinedMaterials = materialProcesses.map((material:any)=>{
  //                     //   const processData = this.combinedMaterials.filter((p:any)=>{
  //                     //       return (p.material === material.material || p.material === material.extMat)
  //                     //   })
  //                     //   console.log(processData)
  //                     //   if(processData.length > 0)
  //                     //   {
  //                     //     return {
  //                     //       ...material,
  //                     //       process: material.process,
  //                     //       processId: material.processId,
  //                     //       density: material.density  || processData[0].density ,
  //                     //       thickness: material.thickness || processData[0].thickness,
  //                     //       waste: processData[0].waste // Preserve original waste value
  //                     //     };
  //                     //   }
  //                     //   else
  //                     //   {
  //                     //     return {
  //                     //       material: 'WIP',
  //                     //       process: material.process,
  //                     //       processId: material.processId,
  //                     //       density: 0,        // Default density for WIP
  //                     //       thickness: 0,      // Default thickness for WIP
  //                     //       width:0,       // Default width for WIP
  //                     //       gsm: 0,
  //                     //       waste: 0 // Preserve original waste value
  //                     //     };
  //                     //   }
  //                     // })
  //                     // console.log(TempProcess)





  
  //                     // Handle WIP material separately
  //                     const lastMaterial = this.combinedMaterials[this.combinedMaterials.length - 1];
  //                     console.log(lastMaterial)
  //                     const lastMaterialWaste = lastMaterial ? lastMaterial.waste : 1; // Fallback to default if no materials
  
  //                     materialProcesses.forEach((process:any)=>{
  //                       if(process.material == 'WIP')
  //                       {
  //                         // if (!this.combinedMaterials.some((material: any) => material.material === 'WIP')) {
  //                           this.combinedMaterials.push({
  //                             material: 'WIP',
  //                             process: process.process,
  //                             processId: process.processId,
  //                             density: 0,        // Default density for WIP
  //                             thickness: 0,      // Default thickness for WIP
  //                             width:0,       // Default width for WIP
  //                             waste: lastMaterialWaste, // Use waste from the last material
  //                             gsm: 0            // Default GSM for WIP if necessary
  //                           });
  //                         // }
  //                       }
  //                     })

  //                     // const wipProcess = materialProcesses.find((process: any) => process.material === 'WIP');
  //                     // console.log(wipProcess)
  //                     // if (wipProcess) {
  //                     //   // Add WIP material only if it does not already exist in combinedMaterials
  //                     //   if (!this.combinedMaterials.some((material: any) => material.material === 'WIP')) {
  //                     //     this.combinedMaterials.push({
  //                     //       material: 'WIP',
  //                     //       process: wipProcess.process,
  //                     //       processId: wipProcess.processId,
  //                     //       density: 0,        // Default density for WIP
  //                     //       thickness: 0,      // Default thickness for WIP
  //                     //       width:0,       // Default width for WIP
  //                     //       waste: lastMaterialWaste, // Use waste from the last material
  //                     //       gsm: 0            // Default GSM for WIP if necessary
  //                     //     });
  //                     //   }
  //                     // }
  
  //                     console.log('Combined Materials with Processes:', this.combinedMaterials);
  
  //                     // Perform calculations and updates
  //                     this.calculateGrandTotalGsm();
  //                     this.calculateAndLogGsm();
  //                     this.cdr.detectChanges();
  //                   } else {
  //                     console.warn('No MatAllot data found for jssId:', jssId);
  //                   }
  //                 },
  //                 (err: any) => {
  //                   console.error('Error fetching MatAllot data:', err);
  //                 }
  //               );
                
  //             } else {
  //               console.warn('No MatMix data found for jssId:', jssId);
  //             }
  //           },
  //           (err: any) => {
  //             console.error('Error fetching MatMix data:', err);
  //           }
  //         );
  //       } else {
  //         console.error('No data found for jssId:', jssId);
  //       }
  //     },
  //     (error) => {
  //       console.error('Error fetching JSS details:', error);
  //     }
  //   );
  // }


// import { Component, OnInit } from '@angular/core';
// import { FormBuilder, FormGroup, Validators } from '@angular/forms';
// import { ActivatedRoute } from '@angular/router';
// import { ClientsService } from '@app/shared/services/clients.service';
// import { OrderService } from '@app/shared/services/order.service';
// import { Router } from '@angular/router';

// @Component({
//   selector: 'app-place-order',
//   templateUrl: './place-order.component.html',
//   styleUrls: ['./place-order.component.css']
// })
// export class PlaceOrderComponent implements OnInit {
//   clientList: any[] = [];
//   orderId: string;
//   showOrder = true;
//   formData: any = {};
//   orderForm: FormGroup;
//   addOrderForm: FormGroup;
//   selectedClient: any;
//   ticketno: string | null;

//   constructor(
//     private formBuilder: FormBuilder,
//     private orderService: OrderService,
//     private clientService: ClientsService,
//     private activatedRoute: ActivatedRoute,
//     private router: Router,

//   ) {}

//   ngOnInit(): void {

//     this.orderForm = this.formBuilder.group({
//       clientName: ['', [Validators.required]],
//       orderOption: ['', [Validators.required]],
//     });

//     this.addOrderForm = this.formBuilder.group({
//       ticketno: ['', [Validators.required]],
//       clientName: ['', [Validators.required]],
//       refNo: ['', [Validators.required]],
//       poNo: ['', [Validators.required]],
//       jobName: ['', [Validators.required]],
//       jobType: ['', [Validators.required]],
//       orderKgs: ['', [Validators.required]],
//       fdOption: ['', [Validators.required]],
//     });
//     this.getClients();
//   }

//   getClients() {
//     this.clientService.getClientList().subscribe(
//       (data: any) => {
//         this.clientList = data;
//       },
//       (error) => {
//         console.error('Error fetching clients:', error);
//       }
//     );
//   }
  
//   toggleView() {
//     this.showOrder = !this.showOrder;
//     this.formData = {}; // Reset form data when switching views
//   }

  
//   NewJob() {
//     if (this.orderForm.get('orderOption').value === 'newJob') {
//       // Check if the selected order option is "newJob"
//       const selectedClientId = this.orderForm.get('clientName').value;
  
//       // Store the selected client
//       this.selectedClient = this.clientList.find(client => client._id === selectedClientId);
  
//       // Set the clientName in the "Place and Save Order" form
//       this.addOrderForm.get('clientName').setValue(this.selectedClient?.clientName);
  
//       // Set the ticketno in the "Place and Save Order" form
//       this.addOrderForm.get('ticketno').setValue(this.selectedClient?.ticketno || '');
  
//       // Navigate to the "Place and Save Order" form
//       this.showOrder = false;
//     }
//   }

//   addOrder(): void {
//     console.log('Form Data:', this.addOrderForm.value);
//     if (this.addOrderForm.valid) {
//         this.orderService.addOrder(this.addOrderForm.value).subscribe(
//           (res: any) => {
//             console.log(res);
//             this.addOrderForm.reset();
//             this.router.navigate(['/orderList']);

//           },
//           (err: any) => {
//             console.log(err);
//           }
//         );
//       }
//     }
// }

